// extracted by mini-css-extract-plugin
module.exports = {"RecentPunchlists":"RecentPunchlists_RecentPunchlists__1Ef5_"};